import css from 'styled-jsx/css';

export default css`:global(.Modal) {
  position: fixed;
  height: 0;
  overflow: hidden;
  max-width: 400px;
  width: 80%;
  top: 50%;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  color: #666;
  background-color: white;
  transform: translateX(0%) translateY(120%);
  border-radius: 4px;
  box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  z-index: 1101;
  transition: all .3s; }

:global(.ReactModal__Content--after-open.Modal) {
  height: auto;
  overflow: auto;
  transition: all .3s;
  transform: translateX(0%) translateY(0%);
  opacity: 1;
  visibility: visible;
  z-index: 1102; }

:global(.ReactModal__Content--before-close.Modal) {
  opacity: 0; }

:global(.ReactModal__Modal) {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  background-color: papayawhip; }

:global(.Overlay) {
  visibility: visible;
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1100;
  transition: background-color 300ms;
  display: flex;
  justify-content: center; }

:global(.ReactModal__Overlay--after-open) {
  background-color: rgba(0, 0, 0, 0.5); }

:global(.ReactModal__Overlay--before-close) {
  background-color: rgba(0, 0, 0, 0); }

.content {
  padding: 16px;
  text-align: left;
  color: #414141;
  letter-spacing: .4px; }
  .content .titleBar {
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .content .title {
    width: 169px;
    height: 24px;
    font-size: 1.25em;
    font-weight: 500; }
  .content .closeBtn {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer; }
  .content .message {
    margin-top: 8px;
    font-size: .875em;
    line-height: 1.71; }
`